import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from '@rappi/rests-commons-front';
import GlobalStyles from '../styles/GlobalStyles';
import '../translations/i18n';
var BaseThemeProvider = function (_a) {
    var children = _a.children;
    return (
    // @ts-ignore
    _jsxs(ThemeProvider, { theme: "ligth", children: [_jsx(GlobalStyles, {}), children] }));
};
export default BaseThemeProvider;
